import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

export const TransactionPending = ({ refreshTransaction, children }) => {
  const refreshRef = useRef(refreshTransaction);

  useEffect(() => {
    refreshRef.current = refreshTransaction;
  }, [refreshTransaction]);

  useEffect(() => {
    const interval = window.setInterval(
      () => refreshRef.current(),
      window.VetsGov.pollTimeout || 1000,
    );
    return () => window.clearInterval(interval);
  }, []);

  if (children) {
    return <div>{children}</div>;
  }

  return (
    <div>
      <va-loading-indicator
        label="Updating"
        message="Updating your information..."
        set-focus
        data-testid="loading-indicator"
      />
    </div>
  );
};

TransactionPending.propTypes = {
  refreshTransaction: PropTypes.func.isRequired,
  children: PropTypes.node,
};
